/*
 * @Author: cc
 * @LastEditTime: 2023-12-27 13:22:16
 */

import logo from "@root/img/logo_company.png";
import { useEffect, useState } from "react";
import {
  UserOutlined,
  EyeInvisibleOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import { setRegisterType } from "@root/reducers/register";
import {
  getCodeImage,
  login,
  getUserInfo,
  getUserInfoByUserId,
  getAuthMenuData,
} from "@root/common/service";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo } from "@root/reducers/user";
import "./_index.scss";
import { RootState } from "@root/store";
import {
  queryInstituteList,
  postLeaveAdvertisementTime,
} from "@root/common/utils";
import ConfirmUserInfo from "@root/pages/home/confirmUserInfo/index";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
const { Search } = Input;

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const courseId = searchParams.get("courseId") || "";
  const { xy_home_login } = useSelector(
    (state: RootState) => state.advertisementData
  );
  const dispatch = useDispatch();
  const [showConfirmUserInfo, setShowConfirmUserInfo] = useState(false);
  const [imgCode, setImgCode] = useState({
    url: "",
    uuid: "",
  });
  /**
   * 获取验证码
   */
  const queryGetCodeImage = async () => {
    const { img, uuid } = await getCodeImage();
    setImgCode({
      url: `data:image/gif;base64,${img}`,
      uuid,
    });
  };
  /**
   * 登录
   * @param values
   */
  const onFinish = async (values: any) => {
    const { uuid } = imgCode;
    const { username } = values;
    const {
      code,
      data: { access_token },
    } = await login({ uuid, ...values });
    if (code === 200) {
      dispatch(
        setUserInfo({
          access_token,
          userName: username,
        })
      );
      // 获取用户详情
      const {
        user: {
          userName,
          instituteId,
          baseUserCategory,
          userId,
          mainFlag,
          confirmFlag,
          uumsId,
        },
        institute: { baseRegistrationStatus, provinceCode, isCountyProject },
      } = await getUserInfo();
      const { data = [] } = await getUserInfoByUserId(userId);
      const authMenuData = await getAuthMenuData();
      const roleMap = Object.keys(authMenuData.data);
      // 需要补充信息
      if (confirmFlag === "2") {
        dispatch(setRegisterType("login"));
        setShowConfirmUserInfo(true);
      } else {
        // 未登录到首页，进行重定向
        if (courseId) {
          navigate(`/play?courseId=${courseId}`);
        } else {
          dispatch(
            setUserInfo({
              access_token,
              userName,
              instituteId,
              baseUserCategory,
              baseRegistrationStatus,
              userDetailInfo: data[0],
              provinceCode,
              userId,
              isCountyProject,
              roleMap,
              mainFlag,
              uumsId,
            })
          );
          navigate("/home/index");
        }
      }
    }
  };
  useEffect(() => {
    queryGetCodeImage();
    queryInstituteList("");
  }, []);
  useEffect(() => {
    var startTime = new Date().valueOf() / 1000;
    return () => {
      postLeaveAdvertisementTime(xy_home_login, startTime);
    };
  }, []);
  return (
    <div
      className="login_box"
      style={{
        background: `url(${
          xy_home_login.length > 0 ? xy_home_login[0].imageUrl : ""
        })`,
        backgroundSize: "100% 100%",
      }}
    >
      <div className="submit_box">
        <h2>登录</h2>
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
          style={{
            width: "360px",
            margin: "0 auto",
          }}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: "请输入用户名" }]}
          >
            <Input
              size="large"
              addonBefore={<UserOutlined />}
              placeholder="请输入用户名"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: "请输入密码" }]}
          >
            <Input.Password
              size="large"
              addonBefore={<EyeInvisibleOutlined />}
              placeholder="请输入密码"
            />
          </Form.Item>
          <Form.Item
            name="code"
            rules={[{ required: true, message: "请输入图形验证码" }]}
          >
            <Search
              placeholder="请输入图形验证码"
              allowClear
              style={{
                padding: 0,
              }}
              enterButton={
                <img
                  src={imgCode.url}
                  alt=""
                  style={{
                    width: "90px",
                    height: "100%",
                  }}
                  onClick={queryGetCodeImage}
                />
              }
              size="large"
              addonBefore={<SafetyCertificateOutlined />}
            />
          </Form.Item>
          <Form.Item name="remember" valuePropName="checked">
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Link to="/register">注册账户</Link>
            </div>
          </Form.Item>
          <Form.Item
            style={{
              textAlign: "center",
            }}
          >
            <Button type="primary" htmlType="submit">
              登录
            </Button>
          </Form.Item>
        </Form>
      </div>
      <ConfirmUserInfo
        setShowConfirmUserInfo={setShowConfirmUserInfo}
        showConfirmUserInfo={showConfirmUserInfo}
      />
    </div>
  );
};
export default Login;
